const React = require('react');
const StockExchangeIndexVariation = require('./stockExchangeIndexVariation');

class StockExchangeIndexVariationSplitted extends StockExchangeIndexVariation {

    showVariation(plusOrLessPts, variationPts, plusOrLessPercentage, variationPerc) {
        return (
            <span>
                {plusOrLessPts}{variationPts}<br />{plusOrLessPercentage}{variationPerc}%
            </span>
        );
    }
}

module.exports = StockExchangeIndexVariationSplitted;
